/* qv-reveal: scroll reveal, built so it can never leave a blank band.
 *
 * Three settings that are not details, all learned the hard way:
 *   rootMargin 110%  reveal a FULL VIEWPORT before the element arrives, so the transition
 *                    has finished by the time it is on screen. At the viewport edge a fast
 *                    mobile flick lands on plain background for most of a second.
 *   threshold 0      fire on first pixel, not on 5% which is unreliable on mobile.
 *   6000ms deadline  whatever the observer does or does not do, nothing on this site stays
 *                    hidden waiting for a scroll.
 *
 * The .qv-js class is added inline in qv-header.liquid, not here, so there is no frame
 * where content is visible, hidden, then revealed. If this file never loads, .qv-js is
 * still set but nothing is hidden, because the hiding rule also requires the CSS in
 * qv-head.liquid, which reveals on .is-in only under prefers-reduced-motion: no-preference.
 */
(function () {
  var nodes = document.querySelectorAll('.qv-reveal');
  if (!nodes.length) return;

  function showAll() {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    showAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) {
        entries[i].target.classList.add('is-in');
        io.unobserve(entries[i].target);
      }
    }
  }, { rootMargin: '110% 0px 110% 0px', threshold: 0 });

  for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);

  setTimeout(function () { io.disconnect(); showAll(); }, 6000);
})();
